import { useEffect, useRef, useState } from "react";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
// import { EVIDENCE_TIMELINE_TABLE_DATA } from "../constants/data.cnst";
// import type { EVIDENCE_TIMELINE_TABLE } from "../interfaces/dashboard";
import type { MenuItem } from "primereact/menuitem";
import { BreadCrumb } from "primereact/breadcrumb";
import { IconAlertTriangle, IconArrowLeft, IconCalendar, IconDownload, IconFileTypeDocx, IconFileTypePdf } from "@tabler/icons-react";
import { Card } from "primereact/card";
import Table from "../components/table";
import { useLocation, useNavigate } from "react-router-dom";
import { Tag } from "primereact/tag";
import LineChart from "../components/line-chart";
// import { Accordion, AccordionTab } from "primereact/accordion";
import { useMutation, useQuery } from "@tanstack/react-query";
import { fetchApi } from "../services/http.service";
import { APIMapping } from "../constants/api-mapping.cnst";
import { Skeleton } from "primereact/skeleton";
import { useReactToPrint } from "react-to-print";
import { Button } from "primereact/button";
import { getSeverity } from "../services/util.service";
import { Accordion, AccordionTab } from "primereact/accordion";
import { HBL_PA_RESOURCES } from "../constants/data.cnst";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { Checkbox } from "primereact/checkbox";

export default function EventRCA() {
  const eventTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.EVIDENCE_TIMELINE;
  const navigate = useNavigate();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const eventId = params.get('eventId');
  // const fromDate = params.get("fromDate");
  // const toDate = params.get("toDate");

  // const [evidenceTimelineTableData, setEvidenceTimelineTableData] = useState<EVIDENCE_TIMELINE_TABLE[]>([]);

  // useEffect(() => {
  //   setEvidenceTimelineTableData(EVIDENCE_TIMELINE_TABLE_DATA)
  // }, []);

  const handleNavigateToDashboard = () => {
    const searchParams = new URLSearchParams(location.search);

    // remove eventId
    searchParams.delete("eventId");
    // remove tripId
    searchParams.delete("tripId");

    navigate({
      pathname: "/dashboard",
      search: searchParams.toString(),
    });
  };

  // const handleBack = () => {
  //   const path = localStorage.getItem(RCA_BACK_BUTTON) || "/dashboard";
  //   localStorage.removeItem(RCA_BACK_BUTTON)

  //   navigate(path, { replace: true });

  // }

  const breadcrumb: MenuItem[] = [
    { label: 'Loco Events', command: () => handleNavigateToDashboard(), style: { fontWeight: 500 } },
    { label: 'Root Cause Analysis', style: { pointerEvents: 'none' }, className: 'font-semibold text-gray-900' }
  ];

  //event details api
  const { data: eventsResponseData, isFetching: isEventResponseLoading } = useQuery({
    queryKey: ["events-data", eventId],
    queryFn: () =>
      fetchApi({
        endpoint: APIMapping.EVENTS_DETAILS,
        pathParams: { eventId: eventId as string },
        resourceName: HBL_PA_RESOURCES.EVENTS
      }),
    enabled: Boolean(eventId)
  });

  const eventSummary = {
    "Loco ID": eventsResponseData?.response?.locoId ?? '-',
    "Station ID": eventsResponseData?.response?.stationId ?? '-',
    "Station Name": eventsResponseData?.response?.stationName ?? '-',
    Zone: eventsResponseData?.response?.zoneName ?? '-',
    "Project": eventsResponseData?.response?.division ?? '-',
    "Timestamp": eventsResponseData?.response?.eventTimestamp ?? '-',
    "Absolute Location": eventsResponseData?.response?.absoluteLocation || 'NA',
    "Trip ID": eventsResponseData?.response?.tripId ?? '-',
  };

  //train journey api
  // const { data, isFetching: isTripSegmentLoading } = useQuery({
  //   queryKey: ["trip-segments", eventId],
  //   queryFn: () =>
  //     fetchApi({
  //       endpoint: APIMapping.TRIPS_SEGMENTS,
  //       pathParams: { eventId: eventId as string },
  //       resourceName: HBL_PA_RESOURCES.EVENTS
  //     }),
  //   enabled: Boolean(eventId)
  // });

  // const segments = data?.response?.segments ?? [];

  // const stations =
  //   segments.length > 1
  //     ? segments.flatMap((segment: any) => {
  //       const station = {
  //         label: segment.startStationId,
  //         status: "kavach",
  //         stationName: segment.startStationName,
  //         icon: <IconCircleDot className="text-[#f2a2cb]" />,
  //       };

  //       // If event happened → add station first, then alert
  //       if (segment.eventHappened) {
  //         return [
  //           station,
  //           {
  //             label: "",
  //             status: "kavach",
  //             stationName:
  //               eventsResponseData?.response?.eventCategory?.replace("_", " "),
  //             icon: <IconAlertCircle className="text-orange-500" />,
  //           },
  //         ];
  //       }

  //       return [station];
  //     })
  //     : [
  //       {
  //         label: segments[0]?.startStationId ?? "",
  //         status: "kavach",
  //         stationName:
  //           eventsResponseData?.response?.eventCategory?.replace("_", " "),
  //         icon: <IconAlertCircle className="text-orange-500" />,
  //       },
  //     ];

  // const pdfTrainStations =
  //   stations.length > 7
  //     ? stations.flatMap((station: any, i: number) =>
  //       station.icon?.type?.displayName === "AlertCircle"
  //         ? stations.slice(Math.max(0, i - 3), i + 4)
  //         : []
  //     )
  //     : [];


  const [isPrinting, setIsPrinting] = useState(false);

  // const trainJourneyData =
  //   isPrinting && pdfTrainStations.length > 0
  //     ? pdfTrainStations
  //     : stations;
  const toast = useRef<Toast>(null);

  const { mutateAsync: downloadReport, isPending: isDownloading } = useMutation({
    mutationFn: (format: "PDF" | "DOCX") =>
      fetchApi({
        endpoint: APIMapping.DOWLOAD_LOCO_RCA_REPORT,
        responseType: "blob",
        queryParams: {
          eventId,
          format,
          eventCategory: eventsResponseData?.response?.eventCategory,
          rcaTypes: Object.keys(eventsResponseData?.response?.rcaAnalysisJson ?? {}).filter(category => category !== 'evidenceTimeline').filter((_, index) => activeIndexes.includes(index)).join(',')
        },
        resourceName: HBL_PA_RESOURCES.EVENTS
      })
  });

  const handleDownload = async (format: "DOCX" | "PDF") => {
    try {
      const result = await downloadReport(format);

      const blob = result.data as Blob;

      const contentDisposition = result.headers.get("content-disposition");
      let fileName = `RCA-Report-${eventId}`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?([^"]+)"?/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);

      toast.current?.show({
        severity: "success",
        summary: "Success",
        detail: `RCA report downloaded successfully`,
        life: 3000
      });
    } catch (err) {
      console.error("Download failed", err);

      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Unable to download report. Please try again.",
        life: 4000
      });
    }
  };

  const items = [
    {
      label: "PDF",
      icon: <IconFileTypePdf />,
      command: () => {
        handleDownload("PDF");
      }
    },
    {
      label: "WORD",
      icon: <IconFileTypeDocx />,
      command: () => {
        handleDownload("DOCX");
      }
    }
  ];
  const menu = useRef<Menu>(null);
  const [activeIndexes, setActiveIndexes] = useState<number[]>([]);

  useEffect(() => {
    setActiveIndexes([...Array(Object.keys(eventsResponseData?.response?.rcaAnalysisJson ?? {}).filter(categoryKey => categoryKey !== 'evidenceTimeline').length).keys()]);
  }, [eventsResponseData]);

  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    contentRef: printRef,
    documentTitle: `RCA_Event_${eventId}`,

    onBeforePrint: () =>
      new Promise<void>((resolve) => {


        const isDark = document.documentElement.classList.contains("dark");

        if (isDark) {
          printRef.current?.classList.add("print-dark");
        }
        setIsPrinting(true);
        setTimeout(() => {
          resolve();
        }, 1000);
      }),

    onAfterPrint: () => {
      printRef.current?.classList?.remove("print-dark");
      setIsPrinting(false);
    },

    onPrintError: (error) => {
      console.error("Print error:", error);
      printRef.current?.classList?.remove("print-dark");
    }
  });

  const { data: rfStrenthData, isFetching: isRFStrenthLoading } = useQuery({
    queryKey: ["rfStrenth", eventsResponseData?.response?.locoId],
    queryFn: () =>
      fetchApi({
        endpoint: APIMapping.SPEED_RFSTRENGTH,
        queryParams: {
          locoId: eventsResponseData?.response?.locoId as string,
          timestamp: eventsResponseData?.response?.eventTimestamp.replaceAll(',', '')
        },
        resourceName: HBL_PA_RESOURCES.EVENTS
      }),
    enabled: Boolean(eventsResponseData?.response?.locoId)
  });

  const { data: speedData, isFetching: isSpeedLoading } = useQuery({
    queryKey: ["speed-chart", eventsResponseData?.response?.locoId],
    queryFn: () =>
      fetchApi({
        endpoint: APIMapping.SPEED_VS_TIME,
        queryParams: {
          locoId: eventsResponseData?.response?.locoId as string,
          timestamp: eventsResponseData?.response?.eventTimestamp.replaceAll(',', '')
        },
        resourceName: HBL_PA_RESOURCES.EVENTS
      }),
    enabled: Boolean(eventsResponseData?.response?.locoId)
  });

  // const { data: evidenceTimelineResponseData, isFetching: isEvidenceTimelineLoading } = useQuery({
  //   queryKey: ["evidence-timiline", eventId],
  //   queryFn: () =>
  //     fetchApi({
  //       endpoint: APIMapping.EVIDENCE_TIMELINE,
  //       queryParams: {
  //         event_id: eventId as string,
  //       },
  //       resourceName: HBL_PA_RESOURCES.EVENTS
  //     }),
  //   enabled: Boolean(eventId)
  // });

  // const totalRecordsForEvidenceTimeline = evidenceTimelineResponseData?.response?.total_entries;


  const extractSecondsAndMillis = (timestamp: string) => {
    const timePart = timestamp.split(" ")[0]; // HH:MM:SS:MS
    const parts = timePart.split(":");
    return `${parts[2]}:${parts[3]}`; // SS:MS
  };

  const buildRFStrengthChartData = (response: any[]) => {
    const isRadioHole = (value: any) =>
      value !== null &&
      value !== undefined &&
      Number(value) > 5;

    return {
      labels: response.map((item) =>
        extractSecondsAndMillis(item.TimeStamp)
      ),

      datasets: [
        {
          label: "RF Strength",
          data: response.map((item) => item.RfSigStrength),

          absLocation: response.map((item) => item.AbsLocation),

          tcasMode: response.map((item) =>
            item.tcasMode?.replace("_", " ")
          ),

          event: response.map((item) =>
            item.nearest
              ? eventsResponseData?.response?.eventCategory?.replace(
                "_",
                " "
              ) ?? "-"
              : ""
          ),

          fill: false,
          borderColor: "#6366f1",
          backgroundColor: "#6366f1",
          tension: 0.4,

          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: "#ffffff",

          // Make invalid (> 5) points red
          pointBorderColor: response.map((item) =>
            isRadioHole(item.RfSigStrength)
              ? "#ef4444"
              : item.nearest
                ? "#F18226"
                : "#6366f1"
          ),

          pointBorderWidth: 2,

          // Make segments containing invalid values dotted + red
          segment: {
            borderColor: (ctx: any) => {
              const y1 = ctx.p0?.parsed?.y;
              const y2 = ctx.p1?.parsed?.y;

              return isRadioHole(y1) || isRadioHole(y2)
                ? "#ef4444"
                : "#6366f1";
            },

            borderDash: (ctx: any) => {
              const y1 = ctx.p0?.parsed?.y;
              const y2 = ctx.p1?.parsed?.y;

              return isRadioHole(y1) || isRadioHole(y2)
                ? [6, 6]
                : [];
            }
          }
        },

        // Dummy dataset only for the legend
        {
          label: "Radio Hole",
          data: [],
          borderColor: "#ef4444",
          backgroundColor: "#ef4444",
          borderDash: [6, 6],

          pointRadius: 0,
          pointHoverRadius: 0
        }
      ]
    };
  };

  const buildSpeedTimeChartDataForOtherEvents = (response: any[]) => {
    const isAllZero =
      response.length > 0 &&
      response.every((item: any) => item.CurrentSpeed === 0);
    return {
      labels: response.map(item =>
        extractSecondsAndMillis(item.TimeStamp)
      ),

      isAllZero,

      datasets: [
        {
          label: "Speed",
          data: response.map(item => item.CurrentSpeed),
          absLocation: response.map(item => item.AbsLocation),
          tcasMode: response.map(item => item.tcasMode?.replace('_', ' ')),
          event: response.map(item =>
            item.nearest ?
              eventsResponseData?.response?.eventCategory?.replace('_', ' ') ?? '-' : ""



          ),

          fill: false,
          borderColor: "#6366f1",
          backgroundColor: response.map(item =>
            item.nearest ? "#F18226" : "#6366f1"
          ),
          tension: 0.4,
          pointRadius: 4,
          pointHoverRadius: 6,
          pointBackgroundColor: "#ffffff",
          pointBorderColor: response.map(item =>
            item.nearest ? "#F18226" : "#6366f1"
          ),
          pointBorderWidth: 2
        }
      ]
    };
  };

  const buildSpeedTimeChartDataForSlipEvents = (response: any[]) => {
    const isAllZero =
      response.length > 0 &&
      response.every(
        (item: any) =>
          (item.Spd ?? 0) === 0 &&
          (item.Pg1Spd ?? 0) === 0 &&
          (item.Pg2Spd ?? 0) === 0
      );

    return {
      labels: [
        0,
        ...response.map((item) =>
          extractSecondsAndMillis(item.TimeStamp)
        ),],

      isAllZero,

      datasets: [
        {
          label: "Speed",
          data: [null, ...response.map((item) => item.Spd)],
          absLocation: response.map((item) => item.AbsLocation),
          tcasMode: response.map((item) =>
            item.tcasMode?.replace("_", " ")
          ),
          event: response.map((item) =>
            item.nearest
              ? eventsResponseData?.response?.eventCategory?.replace("_", " ") ?? "-"
              : ""
          ),

          fill: false,
          borderColor: "#6366f1",
          backgroundColor: "#6366f1",
          tension: 0.4,
          pointRadius: response.map((item) =>
            item.nearest ? 4 : 3
          ),
          pointBackgroundColor: "#ffffff",
          pointBorderColor: response.map((item) =>
            item.nearest ? "#F18226" : "#6366f1"
          ),
        },

        ...(eventsResponseData?.response?.eventCategory?.startsWith("SLIP")
          ? [
            {
              label: "PG1 Speed",
              data: [null, ...response.map((item) => item.Pg1Spd)],
              fill: false,
              borderColor: "#A52960",
              backgroundColor: "#A52960",
              tension: 0.4,
              pointRadius: response.map((item) =>
                item.nearest ? 4 : 3
              ),
              pointBackgroundColor: "#ffffff",
              pointBorderColor: response.map((item) =>
                item.nearest ? "#F18226" : "#A52960"
              ),
            },
            {
              label: "PG2 Speed",
              data: [null, ...response.map((item) => item.Pg2Spd)],
              fill: false,
              borderColor: "#22c55e",
              backgroundColor: "#22c55e",
              tension: 0.4,
              pointRadius: response.map((item) =>
                item.nearest ? 4 : 3
              ),
              pointBackgroundColor: "#ffffff",
              pointBorderColor: response.map((item) =>
                item.nearest ? "#F18226" : "#22c55e"
              ),
            },
          ]
          : []),
      ],
    };
  };

  const rfStrengthTimeData = buildRFStrengthChartData(rfStrenthData?.response ?? []);
  const speedTimeChartData = eventsResponseData?.response?.eventCategory?.startsWith("SLIP") ? buildSpeedTimeChartDataForSlipEvents(speedData?.response ?? []) : buildSpeedTimeChartDataForOtherEvents(rfStrenthData?.response ?? []);


  return (
    <div className="h-[calc(100vh-4rem)] p-6 flex-1 overflow-y-auto">
      <Toast ref={toast} position="top-right" />

      <div className="flex items-center gap-1">
        <IconArrowLeft
          onClick={() => { handleNavigateToDashboard(); }}
          className="cursor-pointer"
        />
        <BreadCrumb model={breadcrumb} className="p-2!" />

        {!eventsResponseData?.response?.eventCategory.startsWith('UNDESIRABLE') &&
          <Button
            label="Download"
            disabled={isEventResponseLoading || isRFStrenthLoading}
            icon={<IconDownload size={20} />}
            className="ml-auto mb-2 bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500 "
            onClick={handlePrint}
          />}

        {eventsResponseData?.response?.eventCategory.startsWith('UNDESIRABLE') &&
          <>
            <Button
              label="Download"
              icon={<IconDownload size={20} />}
              loading={isDownloading}
              disabled={isDownloading || isEventResponseLoading || isRFStrenthLoading}
              className="ml-auto mb-2 bg-brand-600 border-brand-600 text-white dark:bg-brand-400 dark:border-brand-500 "
              onClick={(event) => menu.current?.toggle(event)}
            />
            <Menu
              popup
              ref={menu}
              model={items}
              id="popup_menu"
              popupAlignment="right"
            />
          </>}
      </div>

      <div ref={printRef}>
        <div className="flex items-center justify-between w-full my-3">
          <h2 className="text-xl font-medium">Root Cause Analysis</h2>

        </div>

        {/* ---------- Event Summary ---------- */}
        <div className="grid grid-cols-1 mb-6">
          <Card header="Event Summary">
            {isEventResponseLoading ? (
              <div className="p-4">
                <Skeleton width="100%" height="100px" borderRadius="10px" />
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">

                {Object.entries(eventSummary).map(([key, value]) => (
                  <div
                    key={key}
                    className="flex items-center gap-2" // <-- stays horizontal
                  >
                    <span className="text-gray-500 whitespace-nowrap dark:text-gray-100">{key} :</span>
                    <span className="font-medium text-gray-900 dark:text-gray-100">{value}</span>
                  </div>
                ))}

              </div>
            )}
          </Card>
        </div>

        {/* ---------- Root Map Road ---------- */}
        {/* <div className="grid grid-cols-1 mb-6">
          <Card header="Train Journey">
            {isTripSegmentLoading ? (
              <div className="p-4">
                <Skeleton width="100%" height="100px" borderRadius="10px" />
              </div>
            ) : (
              <>
                <Timeline
                  value={trainJourneyData}
                  layout="horizontal"
                  align="top"
                  className="custom-timeline overflow-x-auto"
                  marker={(item) => (
                    <>
                      <Tooltip target={`.marker-${item.label}`} content={item.stationName} position="top" />
                      <span className={`marker-${item.label} text-xl cursor-pointer`}>
                        {item.icon}
                      </span>
                    </>
                  )}
                  content={(item) => (
                    <span className="text-xs whitespace-nowrap truncate leading-tight block w-20">
                      {item.label}
                    </span>
                  )}
                  pt={{
                    event: (options) => {
                      const opts = options as any;
                      const status = opts?.props?.value?.[opts.context.index].status;

                      return {
                        className:
                          status === "kavach"
                            ? "event-kavach"
                            : "event-non-kavach"
                      };
                    }
                  }}
                />
                <div className="legend">
                  <div>
                    <span className="dot kavach" /> Kavach
                  </div>
                </div>
                <style>{`
              .p-timeline-horizontal .event-kavach .p-timeline-event-connector {
                 background: #f2a2cb;
              }
         .legend {
          display: flex;
          justify-content: center;
          gap: 1.5rem;
          margin-top: 1.5rem;
          font-size: 14px;
        }

         .legend .dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          display: inline-block;
          margin-right: 6px;
        }

         .legend .dot.kavach {
          background: #f2a2cb;
        }

         .legend .dot.non-kavach {
          background: #9ca3af;
        }
`}
                </style>
              </>
            )}
          </Card>
        </div> */}

        {/* ---------- Root Cause Analysis Steps ---------- */}
        <div className="grid grid-cols-2 gap-4 mb-6">
          {/* <div className="flex flex-col gap-4 flex-1"> */}
          <Card header="RF Strength Over Time">
            {isRFStrenthLoading ? (<div className="p-4">
              <Skeleton width="100%" height="200px" borderRadius="10px" />
            </div>
            ) : (rfStrenthData?.response?.length === 0 ? <div className="p-4 flex items-center justify-center h-64 font-medium">No Data Available</div> :
              <LineChart id="rf-over-time" data={rfStrengthTimeData} xText="Time (sec)" yText="RF Strength (dBm)" />
            )}

          </Card>

          <Card header="Speed VS Time" className={`${eventsResponseData?.response?.eventCategory.startsWith('SLIP') ? "col-span-2" : ""}`}>
            {isSpeedLoading ? (<div className="p-4">
              <Skeleton width="100%" height="200px" borderRadius="10px" />
            </div>
            ) : ((speedData?.response?.length === 0 && eventsResponseData?.response?.eventCategory?.startsWith("SLIP")) || (rfStrenthData?.response?.length === 0 && !eventsResponseData?.response?.eventCategory?.startsWith("SLIP")) ? <div className="p-4 flex items-center justify-center h-64 font-medium">No Data Available</div> :
              <LineChart id="speed-vs-time" data={speedTimeChartData} xText="Time (sec)" yText="Speed (Kmph)" />
            )}
          </Card>
          {/* </div> */}


          <Card header="Root Cause" className={`${eventsResponseData?.response?.eventCategory.startsWith('SLIP') ? 'col-start-2 row-start-1 h-82' : 'col-start-2 row-start-1 row-span-2'}`}>
            <div className={`${isPrinting ? 'h-auto overflow-visible' : 'h-150 overflow-y-auto'}`}>
              <Card
                className="border border-red-200 rounded-xl shadow-sm"
                pt={{
                  root: {
                    className: "p-2 mb-2"
                  }
                }}
              >
                {/* Header Row */}
                <div className="flex items-start mb-2 gap-3">
                  {isEventResponseLoading ? (
                    <Skeleton width="100%" height="100px" borderRadius="10px" />
                  ) : (
                    <>
                      {/* Left side: Icon + Title */}
                      <div className="text-red-500 text-xl bg-red-50 flex items-center justify-center rounded-lg w-10 h-10">
                        <IconAlertTriangle stroke={1.5} />
                      </div>
                      <div className="flex items-start gap-2 flex-1">


                        <div className="flex flex-col">
                          <div className="text-sm">
                            <span className="font-medium">Event :</span>{" "}
                            <span className="font-semibold text-gray-800 dark:text-gray-100">
                              {eventsResponseData?.response?.eventCategory?.replace('_', ' ') ?? '-'}
                            </span>
                          </div>

                          {/* Date Time */}
                          <div className="text-gray-700 text-sm flex items-center gap-1">
                            <IconCalendar className="dark:text-gray-100" size={16} stroke={2} />
                            <span className="dark:text-gray-100">{eventSummary["Timestamp"]}</span>
                          </div>
                        </div>
                      </div>

                      {/* Right-side badge */}
                      <Tag
                        severity={getSeverity(eventsResponseData?.response?.eventCategory?.replace('_', ' '))}
                        value={eventsResponseData?.response?.eventCategory?.replace('_', ' ') ?? '-'}
                        className="px-3! py-0!"
                      />
                    </>
                  )}
                </div>

                {/* Description */}
                {/* <div className="text-sm text-gray-700 mt-3">
              <ul className="list-disc list-outside ml-5 space-y-1">
                <li>
                  Emergency braking was triggered because the Movement Authority
                  dropped from 50 km to 30 km at 12:45:32.
                </li>
                <li>
                  The sudden reduction resulted in insufficient MA for the locomotive
                  to continue safely.
                </li>
              </ul>
            </div> */}

              </Card>
              <p className="ps-8 text-sm">
                {eventsResponseData?.response?.eventCode}
                <br></br>
                {eventsResponseData?.response?.evidenceSummary}
                {eventsResponseData?.response?.eventCode === 'TAG_MISSING' && (
                  <>
                    <br />
                    Missed Tag: {Object.keys(eventsResponseData?.response?.eventDetailsMap || {})
                      .filter(key => key.startsWith('TagLog'))
                      .map(key => eventsResponseData?.response?.eventDetailsMap[key]?.missed_tag === 0 ? '-' : eventsResponseData?.response?.eventDetailsMap[key]?.missed_tag)
                      .filter(val => val !== undefined && val !== null)
                      .join(', ')}
                    <br />
                    Speed:  {Object.keys(eventsResponseData?.response?.eventDetailsMap || {})
                      .filter(key => key.startsWith('TagLog'))
                      .map(key => eventsResponseData?.response?.eventDetailsMap[key]?.CurrentSpeed === 0 ? '-' : eventsResponseData?.response?.eventDetailsMap[key]?.CurrentSpeed)
                      .filter(val => val !== undefined && val !== null)
                      .join(', ')}
                  </>
                )}
              </p>

              <Accordion multiple activeIndex={activeIndexes} onTabChange={(e) => {
                const indexes = e.index as number[];

                // Always keep at least one tab expanded
                if (indexes.length > 0) {
                  setActiveIndexes(indexes);
                }
              }}>
                {Object.entries(eventsResponseData?.response?.rcaAnalysisJson ?? {}).filter(([categoryKey]) => categoryKey !== 'evidenceTimeline').map(([categoryKey, categoryValue], index) => (
                  <AccordionTab
                    key={categoryKey}
                    header={
                      <div className="flex items-center gap-2 p-3 font-medium text-gray-900 dark:text-gray-100">
                        <Checkbox
                          checked={activeIndexes.includes(index)}
                          onChange={(e) => {
                            setActiveIndexes((prev) => {
                              if (e.checked) {
                                return prev.includes(index) ? prev : [...prev, index];
                              }

                              // Prevent unchecking the last active accordion
                              if (prev.length === 1 && prev.includes(index)) {
                                return prev;
                              }

                              return prev.filter((value) => value !== index);
                            });
                          }}
                          disabled={activeIndexes.length === 1 && activeIndexes.includes(index)}
                          onClick={(e) => e.stopPropagation()}
                        />

                        <span>
                          {categoryKey.replaceAll('_', ' ').toUpperCase()}
                        </span>
                      </div>
                    }
                  >
                    {Object.entries(categoryValue as any).map(([rcaKey, rcaValue]: any) => {
                      if (!rcaValue) return null;

                      return (
                        <div key={rcaKey}>
                          {/* <div className="flex items-center gap-2 font-medium text-gray-900">
                            <IconCaretRightFilled className="dark:text-gray-100" size={16} />
                            <span className="dark:text-gray-100">{rcaKey.replaceAll('_', ' ').toUpperCase()}</span>
                          </div> */}

                          <ul className="mt-2 ml-10 space-y-1 text-sm text-gray-700 list-disc">
                            <li className="dark:text-gray-100">{rcaValue?.description}</li>
                          </ul>
                        </div>
                      );
                    })}
                  </AccordionTab>
                ))}
              </Accordion>
            </div>
          </Card>
        </div>


        {/* ---------- Evidence Timeline ---------- */}
        <div className="grid grid-cols-1 mb-6">
          <Card header="Evidence Timeline">
            <Table
              columns={eventTableColumns}
              data={eventsResponseData?.response?.evidenceTimeline ?? []}
              showGridlines={true}
              paginator={false}
              first={0}
              rows={10}
              isLoading={isEventResponseLoading}
              // totalRecords={totalRecordsForEvidenceTimeline}
              enableScroll={true}
              renderCell={(rowData, field) => {
                return (
                  <div className="flex flex-wrap gap-2">
                    {rowData[field].map((row: any) => (
                      <>
                        <Tag
                          key={row}
                          value={row}
                          severity={getSeverity(row)}
                        />
                      </>))}
                  </div>
                );
              }}
            />
          </Card>
        </div>

      </div>
    </div>
  );
}